/**
 * Consultation Form Configuration Presets
 *
 * These configurations control the behavior and appearance of the ConsultationForm component.
 * Each config defines button labels, visibility settings, and form behavior.
 */

/**
 * Default/Legacy Configuration
 * - Used on most consultation pages throughout the site
 * - Button labels: "See Available Times" and "Ask A Question"
 * - Shows "OR" divider between action buttons
 * - Handles both scheduling and questions inline (no redirect)
 * - Uses (col-xl-10) on larger screens
 */
export const defaultConsultConfig = {
    id: 'default-consult-form',
    isLegacy: true,
    buttonLabels: {
        schedule: 'See Available Times',
        inquiry: 'Ask A Question',
    },
    title: 'Book Your Free Consult',
    showOrDivider: true,
    redirectOnInquiry: false,
    isWide: true,
};

/**
 * Landing Page Configuration
 * - Used on landing pages (Google V2, homepage, homepage-v2)
 * - Button labels: "Reserve My Spot" and "Get A Custom Quote"
 * - Hides "OR" divider between buttons for cleaner, stacked layout
 * - Redirects to /specials/estimate when "Get A Custom Quote" is clicked
 * - Uses narrow layout
 */
export const consultWithCustomQuoteConfig = {
    id: 'consult-with-quote',
    isLegacy: false,
    buttonLabels: {
        schedule: 'Reserve My Spot',
        inquiry: 'Get A Custom Quote',
    },
    title: 'Get started',
    showOrDivider: false,
    redirectOnInquiry: true,
    isWide: false,
};

/**
 * Ask Question / See Available Times Configuration
 * - Button labels: "See Available Times" and "Ask A Question"
 * - Handles questions inline (no redirect)
 */
export const consultWithAskQuestionSeeAvailableTimes = {
    id: 'consult-with-quote',
    isLegacy: false,
    buttonLabels: {
        schedule: 'See Available Times',
        inquiry: 'Ask A Question',
    },
    title: 'Get started',
    showOrDivider: false,
    redirectOnInquiry: false,
    isWide: false,
};
